import type { IconData } from '@stacksjs/iconify-core'

export const textFormattingTopAndBottomImage: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 0h16v2.5H0zm4.5 4.5h7v7h-7zm11.5 9H0V16h16z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default textFormattingTopAndBottomImage
